import React from 'react'

import { useMainQueryData } from './useMainQueryData'

export const useMainQueryQuestions = () => {
  const surveyGroup = useMainQueryData()

  return React.useMemo(
    () => surveyGroup?.questions ?? [],
    [surveyGroup?.questions],
  )
}
